const store = [
    {
        id: 401,
        storeImg: process.env.PUBLIC_URL + '/images/서산_시청점.png',
        city: '충남',
        name: '서산 시청점',
        address: '충남 서산시 성연면 생동사동길 192-38',
        tell: '041)664-1999',
    },
    {
        id: 402,
        storeImg: process.env.PUBLIC_URL + '/images/전주_인후점.png',
        city: '전북',
        name: '전주 인후점',
        address: '전북 전주시 덕진구 동가재미1길 24',
        tell: '063)244-8032',
    },
    {
        id: 403,
        storeImg: process.env.PUBLIC_URL + '/images/진해_석동점.png',
        city: '경남',
        name: '진해 석동점',
        address: '경남 창원시 진해구 냉천로 70-1',
        tell: '055)547-4556',
    },
    {
        id: 404,
        storeImg: process.env.PUBLIC_URL + '/images/대구_교대점.png',
        city: '경북',
        name: '대구 교대점',
        address: '대구 남구 중앙대로 187',
        tell: '053)621-5400',
    },
    {
        id: 405,
        storeImg: process.env.PUBLIC_URL + '/images/의정부_민락점.png',
        city: '경기',
        name: '의정부 민락점',
        address: '경기 의정부시 오목로225번길 169',
        tell: '031)852-6382',
    },
    {
        id: 406,
        storeImg: process.env.PUBLIC_URL + '/images/부산_부평점.png',
        city: '부산',
        name: '부산 부평점',
        address: '부산 중구 흑교로 35-1',
        tell: '051)241-8822',
    },
    {
        id: 407,
        storeImg: process.env.PUBLIC_URL + '/images/광양_중마점.png',
        city: '전남',
        name: '광양 중마점',
        address: '전남 광양시 중마중앙로 71',
        tell: '061)791-2688',
    },
    {
        id: 408,
        storeImg: process.env.PUBLIC_URL + '/images/부산_초량점.png',
        city: '부산',
        name: '부산 초량점',
        address: '부산 동구 고관로 40',
        tell: '051)462-8545',
    },
    {
        id: 409,
        storeImg: process.env.PUBLIC_URL + '/images/구미시청점.png',
        city: '경북',
        name: '구미시청점',
        address: '경북 구미시 송정대로 74',
        tell: '054)444-1960',
    },
    {
        id: 410,
        storeImg: process.env.PUBLIC_URL + '/images/화정역점.png',
        city: '전남',
        name: '화정역점',
        address: '경기 고양시 덕양구 화정로 53',
        tell: '031)964-7771',
    },
    {
        id: 411,
        storeImg: process.env.PUBLIC_URL + '/images/화성_향남점.png',
        city: '경기',
        name: '화성 향남점',
        address: '경기 화성시 향남읍 상신하길로298번길 7-7',
        tell: '031)8059-0483',
    },
    {
        id: 412,
        storeImg: process.env.PUBLIC_URL + '/images/광주_수완점.png',
        city: '전남',
        name: '광주 수완점',
        address: '광주 광산구 수완로49번길 6',
        tell: '062)956-3320',
    },
    {
        id: 413,
        storeImg: process.env.PUBLIC_URL + '/images/광주_조선대점.png',
        city: '전남',
        name: '광주 조선대점',
        address: '광주 동구 필문대로 308',
        tell: '062)233-8282',
    },
    {
        id: 414,
        storeImg: process.env.PUBLIC_URL + '/images/광주_첨단점.png',
        city: '전남',
        name: '광주 첨단점',
        address: '광주 광산구 월계로 191',
        tell: '062)971-8245',
    },
    {
        id: 415,
        storeImg: process.env.PUBLIC_URL + '/images/내포_신도시점.png',
        city: '충남',
        name: '내포신도시점',
        address: '충남 홍성군 홍북읍 청사로150번길 10',
        tell: '041)634-7789',
    },
    {
        id: 416,
        storeImg: process.env.PUBLIC_URL + '/images/김포_사우점.png',
        city: '경기',
        name: '김포 사우점',
        address: '경기 김포시 사우중로 92',
        tell: '031)987-8980',
    },
    {
        id: 417,
        storeImg: process.env.PUBLIC_URL + '/images/대전_문지점.png',
        city: '충남',
        name: '대전 문지점',
        address: '대전 유성구 문지로299번길 94-4',
        tell: '042)867-1618',
    },
    {
        id: 418,
        storeImg: process.env.PUBLIC_URL + '/images/광주_계림점.png',
        city: '전남',
        name: '광주 계림점',
        address: '광주 동구 경양로 234',
        tell: '062)225-3320',
    },
    {
        id: 419,
        storeImg: process.env.PUBLIC_URL + '/images/세종_도담점.png',
        city: '충남',
        name: '세종 도담점',
        address: '세종특별자치시 보듬3로 8-12',
        tell: '044)866-5254',
    },
    {
        id: 420,
        storeImg: process.env.PUBLIC_URL + '/images/대구_상인점.png',
        city: '경북',
        name: '대구 상인점',
        address: '대구 달서구 월배로 168',
        tell: '053)636-8588',
    },
    {
        id: 421,
        storeImg: process.env.PUBLIC_URL + '/images/세종_나성점.png',
        city: '충남',
        name: '세종 나성점',
        address: '세종특별자치시 한누리대로 291',
        tell: '044)866-5001',
    },
    {
        id: 422,
        storeImg: process.env.PUBLIC_URL + '/images/성남_시청점.png',
        city: '경기',
        name: '성남시청점',
        address: '경기 성남시 중원구 양현로405번길 17',
        tell: '031)756-0614',
    },
    {
        id: 423,
        storeImg: process.env.PUBLIC_URL + '/images/밀양_삼문점.png',
        city: '경남',
        name: '밀양 삼문점',
        address: '경남 밀양시 중앙로 262',
        tell: '055)355-4047',
    },
    {
        id: 424,
        storeImg: process.env.PUBLIC_URL + '/images/대구_범어점.png',
        city: '경북',
        name: '대구 범어점',
        address: '대구 수성구 동대구로 345',
        tell: '053)744-0088',
    },
    {
        id: 425,
        storeImg: process.env.PUBLIC_URL + '/images/청주_지웰시티점.png',
        city: '충북',
        name: '청주 지웰시티점',
        address: '충북 청주시 흥덕구 대농로 33 ',
        tell: '043)235-8555',
    },
]

export default store;